// extracted by mini-css-extract-plugin
export var label = "_bf-1";
export var reminder = "_bf-0";